<template>
  <section
    class="w-screen h-screen absolute inset-0 flex justify-center items-center z-40"
    @click.self="closeModal"
  >
    <div
      class="min-w-96 h-fit backdrop-blur-lg transition-all z-50"
      :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }"
    >
      <Card>
        <div class="border-b border-white/30 justify-between flex">
          <div class="w-full pb-2">
            <h5 class="text-left font-bold text-lg">{{ title }}</h5>
          </div>
          <XMarkIcon
            id="close-modal"
            @click="closeModal()"
            class="h-6 w-6 cursor-pointer mr-2"
          />
        </div>
        <div class="max-h-[calc(100dvh-100px)] overflow-y-auto">
          <slot></slot>
        </div>
      </Card>
    </div>
  </section>
</template>

<script>
import Card from "@/components/organisms/Card.vue";
import { XMarkIcon } from "@heroicons/vue/24/solid";

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Modal Title",
    },
  },
  components: {
    Card,
    XMarkIcon,
  },
  methods: {
    closeModal() {
      setTimeout(() => {
        this.$emit("closeModal");
      }, 100);
    },
  },
};
</script>
